import classNames from 'classnames';

import { Image } from '~components/Image/Image';

import styles from './image.module.scss';
import { ImageProps } from './types';

export function image(props: ImageProps) {
  if (!props.src) return null;

  return (
    <Image
      {...props}
      className={classNames(props.className, styles.image)}
      alt={props.alt || ''}
      src={props.src}
    />
  );
}
